import React, { useState, useEffect } from 'react';
import { Pie, Bar } from 'react-chartjs-2';
import { filterCandidate } from '../hunting/services';
import { Grid, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Typography } from '@mui/material';
import { CSVLink } from 'react-csv';

const InsightsDashboard = () => {
  const [searchCriteria, setSearchCriteria] = useState({
    // ... (unchanged)
  });

  const [candidates, setCandidates] = useState(null);
  const [searchResults, setSearchResults] = useState(null);

  const handleSearch = async () => {
    try {
      const response = await filterCandidate(searchCriteria);

      if (response.status === 200) {
        const data = response.data;
        setSearchResults(data);
        setCandidates(data);
      } else {
        console.error('Error in search:', response.statusText);
      }
    } catch (error) {
      console.error('Error in search:', error.message);
    }
  };

  useEffect(() => {
    handleSearch();
  }, []); // Assuming you want to perform the search once when the component mounts

  const ages = candidates ? candidates.map(candidate => candidate.age) : [];

  // ... (unchanged code for charts)

  const appliedPositionCounts = candidates
    ? candidates.reduce((counts, candidate) => {
        const position = candidate?.personalInfo?.appliedPosition;
        counts[position] = (counts[position] || 0) + 1;
        return counts;
      }, {})
    : {};

  const appliedPositionRows = Object.entries(appliedPositionCounts).map(([position, count]) => ({ position, count }));
  const totalAppliedPositions = Object.values(appliedPositionCounts).reduce((total, count) => total + count, 0);

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card style={{ background: 'rgba(255, 255, 255, 0.4)', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' }}>
            <div style={{ textAlign: 'center',paddingTop:10,paddingBottom:10 }}>
              <div>
                <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                  Total Candidates: {candidates ? candidates.length : 0}
                </Typography>
                
                {Object.keys(appliedPositionCounts).length > 0 ? (
                  <>
                  
                    <Button variant="contained" color="primary">
                      <CSVLink data={appliedPositionRows} headers={['position', 'count']} filename="applied_positions.csv">
                        Export Data
                      </CSVLink>
                    </Button>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Position</TableCell>
                            <TableCell align="right">Count</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {appliedPositionRows.map((row) => (
                            <TableRow key={row.position}>
                              <TableCell component="th" scope="row">
                                {row.position}
                              </TableCell>
                              <TableCell align="right">{row.count}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </>
                ) : (
                  <p>No data available for Applied Positions</p>
                )}
              </div>
            </div>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default InsightsDashboard;
